/** Href prefix of a link to a guide entry inside rendered Markdown */
export const GUIDE_ENTRY_HREF = '#guide-entry=';

const CITATION = /\[\[([a-z0-9-]+)\]\]/g;

/**
 * Turns the [[entry-id]] citations in an Ask answer into Markdown links named by the
 * entry's title, which the renderer opens in the guide instead of navigating.
 */
export function linkCitations(content: string, titles: Record<string, string>): string {
  return content.replace(CITATION, (_marker, entryId: string) => {
    const title = titles[entryId] ?? entryId;
    return ` [${title}](${GUIDE_ENTRY_HREF}${entryId})`;
  });
}

/** The entry id of a link produced by linkCitations, or null for any other link */
export function citedEntryId(href: string | undefined): string | null {
  if (!href || !href.startsWith(GUIDE_ENTRY_HREF)) return null;
  return href.slice(GUIDE_ENTRY_HREF.length);
}

/** Writes [[entry-id]] citations as the entry's title in brackets, for text copied out of the app */
export function plainCitations(content: string, titles: Record<string, string>): string {
  return content.replace(CITATION, (_marker, entryId: string) => `(${titles[entryId] ?? entryId})`);
}
